<template>
  <!-- Will be depricated & deleted -->
  <v-card-text class="" style="color: #4F4F4F">
    <v-container class="pa-0 text-left">
      <ProductCardWelcomeRow :is-subscribed="isSubscribed" :name="productName" />
      <ProductCardSubscriptionRow :is-subscribed="isSubscribed" :name="productName" />
      <v-row class="pa-3">
        <div style="text-align: start; color: #004C97" class="title">
          Opt-In Required
        </div>
      </v-row>
      <v-row class="pl-5">
        <div>
          Federal law requires your customers to opt-in to receive text messages from your agency. This is mandated by the FCC’s Telephone Consumer Protection Act. HawkSoft automates this opt-in process with the click of a button.
          <a target="_blank" href="https://blog.hawksoft.com/texting-best-practices-tcpa-compliance#h3">Learn More</a>
        </div>
      </v-row>

      <v-row class="pa-3">
        <div style="text-align: start; color: #004C97" class="title">
          Texting not for marketing purposes
        </div>
      </v-row>
      <v-row class="pl-5">
        <div>
          HawkSoft Text Messaging is only for informational texts. HawkSoft does not allow the use of text messaging for marketing purposes.
          <i>
            You may be in violation of federal and/or state regulations if you use texting for marketing purposes.
          </i>
        </div>
      </v-row>

      <v-row class="pa-3">
        <div style="text-align: start; color: #004C97" class="title">
          You get one text messaging phone number
        </div>
      </v-row>
      <v-row class="pl-5">
        <div>
          Your agency is assigned one (1) central text message phone number. Even if multiple staff members are texting a client, that client will see text messages arriving from a single phone number.
        </div>
      </v-row>

      <v-row class="pa-3">
        <div style="text-align: start; color: #004C97" class="title">
          Terms and Conditions
        </div>
      </v-row>
      <v-row class="pl-5">
        <div>
          Your use of HawkSoft Text Messaging implies acceptance of the HawkSoft Text Messaging terms and conditions:
          <a href="https://www.hawksoft.com/terms/text-messaging/">Terms & Conditions</a>
        </div>
      </v-row>
      <v-row class="pa-3">
        <div v-if="!isSubscribed" class="subtitle-1">Click Next to begin setting up your agencies phone number!</div>
      </v-row>
    </v-container>
  </v-card-text>
</template>

<script>
import ProductCardWelcomeRow from '@/components/products/shared/ProductCardWelcomeRow';
import ProductCardSubscriptionRow from '@/components/products/shared/ProductCardSubscriptionRow';

export default {
  name: 'OldTextingWelcome',
  components: {
    ProductCardWelcomeRow,
    ProductCardSubscriptionRow
  },
  props: {
    isSubscribed: {
      type: Boolean,
      required: true
    },
    productName: {
      type: String,
      required: true
    }
  }
};
</script>
